import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Card, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane,
    Carousel, CarouselItem, CarouselControl, CarouselIndicators, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { IChargerRecommendations, IVehicleRecommendations } from './ViewEstimate';


interface IRecommendedEquipment {
    isPrintView: boolean,
    vehicleData: IVehicleRecommendations[],
    chargerData: IChargerRecommendations[]
}

interface ICarouselIndicatorDummy {
    src: number;
}

export const RecommendedEquipment = ({ vehicleData, chargerData, isPrintView }: IRecommendedEquipment) => {
    const imageFilePath = import.meta.env.REACT_APP_IMAGE_LOCATION ? import.meta.env.REACT_APP_IMAGE_LOCATION + "/" : '';
    const [activeTab, setActiveTab] = useState(1);
    const [animating, setAnimating] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [tripletCount, setTripletCount] = useState(0);
    const [carouselIndicatorDummy, setCarouselIndicatorDummy] = useState<ICarouselIndicatorDummy[]>([]);
    const [nonRoadOnly, setNonRoadOnly] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = async () => {
        setDropdownOpen(state => !state);
    }

    useEffect(() => {
        var triplet: number = 0;
        if (vehicleData.length > 0) {
            if (vehicleData.length > 3) {
                triplet = Math.ceil(vehicleData.length / 3);
                setTripletCount(triplet);
            }
            else {
                triplet = 1;
                setTripletCount(triplet);
            }
        }
        setTripletCount(triplet);

        var carouselDummyArray = [];
        for (var i: number = 0; i < triplet; i++) {
            var dummy = { src: i };
            carouselDummyArray.push(dummy);
        }
        setCarouselIndicatorDummy(carouselDummyArray);

        var nonRoadFilterTest = vehicleData.filter(function (o) { return o.vehicleCategoryName !== 'Non-Road Equipment'; });
        if (nonRoadFilterTest.length <= 0) {
            setNonRoadOnly(true);
        }
        else {
            setNonRoadOnly(false);
        }

    }, [vehicleData]);

    const toggle = (tab: React.SetStateAction<number>) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const onExiting = () => {
        setAnimating(true);
    }

    const onExited = () => {
        setAnimating(false);
    }

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === tripletCount - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }

    const nextOnMobile = () => {
        if (animating) return;
        console.log("activeIndex: ", activeIndex);
        console.log("vehicleData.length: ", (vehicleData.length - 1));

        const nextIndex = activeIndex >= (vehicleData.length - 1) ? 0 : activeIndex + 1;
        console.log("nextIndex: ", nextIndex);
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? tripletCount - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const previousOnMobile = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? vehicleData.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const goToIndex = (newIndex: number) => {
        if (animating) return;
        setActiveIndex(newIndex);
    }

    const formatNumber = (value: number) => {
        if (value) {
            var num = Math.round(+value);
            return num.toLocaleString();
        } else {
            return value;
        }
    }

    return (
        <>
            {isPrintView ? (
                <Row className="page-break-before-always componentPadding">
                    <Col>
                        <Row className="contentBlock">
                            <Col className="sectionTitle">
                                <h2 className="css_heading bold">Recommended Equipment</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="recEquipContainer">
                                <div className="recEquipTitleBar">
                                    <div className="recEquipTitle">Vehicles</div>
                                </div>
                                <div className="reqEquipPrintContent">
                                    <Row className="reqEquipResultsContainer">
                                        <Col>
                                            {[...Array(tripletCount)].map((tCount, index) => {
                                                let tripletSet = index * 3;
                                                return (
                                                    <div key={index}>
                                                        {index > 3 && index % 4 === 0 ? (
                                                            <div className="recEquipTitleBar page-break-before-always showInPrintPreviewOnly">
                                                                <div className="recEquipTitle">Vehicles (continued)</div>
                                                            </div>
                                                        ) : ('')}
                                                        <Row className="reqEquipCardRow reqEquipPrintRow">
                                                            {vehicleData.slice(tripletSet, (index + 1) * 3).map((item: IVehicleRecommendations, secondIndex) => {
                                                                return (
                                                                    <Col key={secondIndex} sm={4} index={secondIndex} className="recEquipJustify page-break-after-avoid">
                                                                        <div className="letsStayTogether">
                                                                            <div className="reqEquipCardContainer reqEquipPrintCardTitle">
                                                                                <div className="recCount">{item.replacementVehicleCount}</div>
                                                                                <div className="recType">{item.replacementVehicleType}</div>
                                                                            </div>
                                                                            <div className="reqEquipCardContainer reqEquipPrintCardContainer">
                                                                                <Card className="reqEquipCard">
                                                                                    {item.vehicleCategoryName !== 'Non-Road Equipment' ? (
                                                                                        <div className="cardContent">
                                                                                            <span className="vehicleRange1">Range:</span>
                                                                                            <span className="vehicleRange2">{`${formatNumber(item.avgVehicleRange)} miles`}</span>
                                                                                            <span className="vehicleBattery">{`Battery: ${formatNumber(item.avgBatteryCapacity)}kWh`}</span>
                                                                                        </div>
                                                                                    ) : ('')}
                                                                                </Card>
                                                                                <div className="cardVehicleContainer">
                                                                                    <div className="cardVehicle">
                                                                                        <img src={`${imageFilePath}/${item.imagePath}`} alt={`A ${item.replacementVehicleType}.`} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )
                                                            })}
                                                        </Row>
                                                    </div>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row className={` ${tripletCount === 4 ? 'page-break-before-always' : ''}`}>
                            <Col className="recEquipContainer">
                                <div className="recEquipTitleBar">
                                    <div className="recEquipTitle">Chargers</div>
                                </div>
                                <div className="reqEquipPrintContent">
                                    <Row className="reqEquipResultsContainer">
                                        <Col>
                                            {nonRoadOnly ? (
                                                <Row className="reqEquipCardRow nonRoadRow reqEquipPrintRow">
                                                    <Col sm={12}>
                                                        <p className="nonRoadDescription">
                                                            Recommending chargers for non-road EVs requires a bit more information than we gather here in Fleet Estimator. Our free, comprehensive
                                                            fleet assessment will help clarify your electrification strategy with charger recommendations for every type of electric vehicle, including non-road EVs.
                                                            Please <Link to="/ContactUs" target="_self">contact our program team</Link>.
                                                        </p>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row className="reqEquipCardRow reqEquipPrintRow">
                                                    {chargerData.map((item: IChargerRecommendations, thirdIndex) => {
                                                        return (
                                                            <Col key={thirdIndex} sm={4}>
                                                                <div className="reqEquipCardContainer reqEquipPrintCardTitle">
                                                                    <div className="recCount">{item.replacementChargerCount}</div>
                                                                    <div className="recType">{item.chargerTypeNameLong}</div>
                                                                </div>
                                                                <div className="reqEquipCardContainer reqEquipPrintCardContainer">
                                                                    <Card className="reqEquipChargerCard">
                                                                        <div className="cardChargerContent">
                                                                            <span className="chargerTitle">Charge Load:</span>
                                                                            <span className="chargerDesc">{item.chargeLoadRange}</span>
                                                                            <span className="chargerTitle">Input</span>
                                                                            <span className="chargerDesc1">{item.input}</span>
                                                                        </div>
                                                                    </Card>
                                                                    <div className="cardChargerContainer">
                                                                        <div className="cardCharger">
                                                                            <img src={`${imageFilePath}/${item.imagePath}`} alt={`A ${item.chargerTypeNameLong}.`} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col className="recEquipContainer">
                        <div className="recEquipTitleBar">
                            <Col className="recEquipTitle">Recommended Equipment</Col>
                            <Col className="desktopView tabContainer">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink className={activeTab === 1 ? "active" : ""} onClick={() => { toggle(1); }} >
                                            Vehicles
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={activeTab === 2 ? "active" : ""} onClick={() => { toggle(2); }} >
                                            Chargers
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                            <div className="mobileView dropDownSelection">
                                <Dropdown id="pageAnchorsDropDown" className="pageAnchorsDropDown" direction="down" isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle caret>
                                        <div>{activeTab === 1 ? "Vehicles" : "Chargers"}</div>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className={activeTab === 1 ? "active" : ""} onClick={() => { toggle(1); }} >Vehicles</DropdownItem>
                                        <DropdownItem className={activeTab === 2 ? "active" : ""} onClick={() => { toggle(2); }} >Chargers</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>

                        <TabContent className="reqEquipTabContent" activeTab={activeTab}>
                            <TabPane className={activeTab === 1 ? "active" : ""}>
                                <Row className="reqEquipResultsContainer">
                                    <Col className="desktopView">
                                        <Carousel activeIndex={activeIndex} next={next} previous={previous} interval={false}>
                                            <CarouselIndicators items={carouselIndicatorDummy} activeIndex={activeIndex} onClickHandler={goToIndex} />
                                            {[...Array(tripletCount)].map((tCount, index) => {
                                                let tripletSet = index * 3;
                                                return (
                                                    <CarouselItem onExiting={onExiting} onExited={onExited} key={index}>
                                                        <Row className="reqEquipCardRow">
                                                            {vehicleData.slice(tripletSet, (index + 1) * 3).map((item: IVehicleRecommendations, secondIndex) => {
                                                                return (
                                                                    <Col key={secondIndex} sm={4} index={secondIndex} className="recEquipJustify">
                                                                        <div className="letsStayTogether">
                                                                            <div className="reqEquipCardContainer">
                                                                                <div className="recCount">{item.replacementVehicleCount}</div>
                                                                                <div className="recType">{item.replacementVehicleType}</div>
                                                                            </div>
                                                                            <div className="reqEquipCardContainer">
                                                                                <Card className="reqEquipCard">
                                                                                    <div className="cardCurve"></div>
                                                                                    {item.vehicleCategoryName !== 'Non-Road Equipment' ? (
                                                                                        <div className="cardContent">
                                                                                            <span className="vehicleRange1">Range:</span>
                                                                                            <span className="vehicleRange2">{`${formatNumber(item.avgVehicleRange)} miles`}</span>
                                                                                            <span className="vehicleBattery">{`Battery: ${formatNumber(item.avgBatteryCapacity)}kWh`}</span>
                                                                                        </div>
                                                                                    ) : ('')}
                                                                                </Card>
                                                                                <div className="cardVehicleContainer">
                                                                                    <div className="cardVehicle">
                                                                                        <img src={`${imageFilePath}/${item.imagePath}`} alt={`A ${item.replacementVehicleType}.`} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )
                                                            })}
                                                        </Row>
                                                    </CarouselItem>
                                                )
                                            })}
                                            <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
                                            <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
                                        </Carousel>
                                    </Col>
                                    <Col className="mobileView">
                                        <Carousel activeIndex={activeIndex} next={nextOnMobile} previous={previousOnMobile} interval={false}>
                                            <CarouselIndicators items={vehicleData} activeIndex={activeIndex} onClickHandler={goToIndex} />
                                            {vehicleData.map((item, index) => {
                                                return (
                                                    <CarouselItem onExiting={onExiting} onExited={onExited} key={index}>
                                                        <Row className="reqEquipCardRow">
                                                            <Col key={index} sm={4} index={index} className="recEquipJustify">
                                                                <div className="letsStayTogether">
                                                                    <div className="reqEquipCardContainer">
                                                                        <div className="recCount">{item.replacementVehicleCount}</div>
                                                                        <div className="recType">{item.replacementVehicleType}</div>
                                                                    </div>
                                                                    <div className="reqEquipCardContainer">
                                                                        <Card className="reqEquipCard">
                                                                            <div className="cardCurve"></div>
                                                                            {item.vehicleCategoryName !== 'Non-Road Equipment' ? (
                                                                                <div className="cardContent">
                                                                                    <span className="vehicleRange1">Range:</span>
                                                                                    <span className="vehicleRange2">{`${formatNumber(item.avgVehicleRange)} miles`}</span>
                                                                                    <span className="vehicleBattery">{`Battery: ${formatNumber(item.avgBatteryCapacity)}kWh`}</span>
                                                                                </div>
                                                                            ) : ('')}
                                                                        </Card>
                                                                        <div className="cardVehicleContainer">
                                                                            <div className="cardVehicle">
                                                                                <img src={`${imageFilePath}/${item.imagePath}`} alt={`A ${item.replacementVehicleType}.`} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </CarouselItem>
                                                )
                                            })}
                                            <CarouselControl direction="prev" directionText="Previous" onClickHandler={previousOnMobile} />
                                            <CarouselControl direction="next" directionText="Next" onClickHandler={nextOnMobile} />
                                        </Carousel>
                                    </Col>

                                </Row>
                            </TabPane>
                            <TabPane className={activeTab === 2 ? "active" : ""}>
                                <Row className="reqEquipResultsContainer">
                                    <Col>
                                        {nonRoadOnly ? (
                                            <Row className="reqEquipCardRow nonRoadRow">
                                                <Col sm={12}>
                                                    <p className="nonRoadDescription">
                                                        Recommending chargers for non-road EVs requires a bit more information than we gather here in Fleet Estimator. Our free, comprehensive
                                                        fleet assessment will help clarify your electrification strategy with charger recommendations for every type of electric vehicle, including non-road EVs.
                                                        Please <Link to="/ContactUs" target="_self">contact our program team</Link>.
                                                    </p>
                                                </Col>
                                            </Row>
                                            ) : (
                                            <>
                                            <Row className="reqEquipCardRow">
                                                {chargerData.map((item: IChargerRecommendations, thirdIndex) => {
                                                    return (
                                                        <Col className="recEquipChargerColumn" key={thirdIndex} sm={4} xs={12}>
                                                            <div className="recEquipChargerContainer">
                                                                <div className="reqEquipCardContainer">
                                                                    <div className="recCount">{item.replacementChargerCount}</div>
                                                                    <div className="recType">{item.chargerTypeNameLong}</div>
                                                                </div>
                                                                <div className="reqEquipCardContainer">
                                                                    <Card className="reqEquipChargerCard">
                                                                        <div className="cardCurve"></div>
                                                                        <div className="cardChargerContent">
                                                                            <span className="chargerTitle">Charge Load:</span>
                                                                            <span className="chargerDesc">{item.chargeLoadRange}</span>
                                                                            <span className="chargerTitle">Input</span>
                                                                            <span className="chargerDesc1">{item.input}</span>
                                                                        </div>
                                                                    </Card>
                                                                    <div className="cardChargerContainer">
                                                                        <div className="cardCharger">
                                                                            <img src={`${imageFilePath}/${item.imagePath}`} alt={`A ${item.chargerTypeNameLong}.`} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    )
                                                })}
                                                    </Row>
                                            <Row className="recEquipTextRow">
                                                            <p>The above estimate provides only a general idea about your charger needs, using a conservative one vehicle to one charger ratio. For more specific recommendations please
                                                             &nbsp;<Link to="/ContactUs" target="_self">contact our program team</Link> for a full fleet assessment.</p>
                                                        </Row>
                                                    </>
                                        )}
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            )}

        </>
    )
};
